export default function MaterialsBigIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="182"
      height="79"
      viewBox="0 0 182 79"
      fill="none"
    >
      <path
        d="M105.146 45.0999L107.249 46.3621C107.663 46.6108 107.798 47.1482 107.549 47.5626C107.475 47.6858 107.372 47.7889 107.249 47.8628L91.9 57.0721C91.3457 57.4048 90.6534 57.4048 90.0992 57.0721L74.7502 47.8628C74.3358 47.6141 74.2014 47.0767 74.45 46.6623C74.5239 46.5391 74.627 46.436 74.7502 46.3621L76.8538 45.0999L90.9996 53.5874L105.146 45.0999ZM105.146 36.8749L107.249 38.1371C107.663 38.3858 107.798 38.9232 107.549 39.3376C107.475 39.4608 107.372 39.5639 107.249 39.6378L90.9996 49.3874L74.7502 39.6378C74.3358 39.3891 74.2014 38.8517 74.45 38.4373C74.5239 38.3141 74.627 38.211 74.7502 38.1371L76.8538 36.8749L90.9996 45.3624L105.146 36.8749ZM91.9 20.7901L107.249 29.9996C107.663 30.2482 107.798 30.7857 107.549 31.2001C107.475 31.3233 107.372 31.4263 107.249 31.5002L90.9996 41.2499L74.7502 31.5002C74.3358 31.2516 74.2014 30.7141 74.45 30.2998C74.5239 30.1766 74.627 30.0735 74.7502 29.9996L90.0992 20.7901C90.6534 20.4576 91.3457 20.4576 91.9 20.7901ZM90.9996 24.3316L80.3024 30.7499L90.9996 37.1683L101.697 30.7499L90.9996 24.3316Z"
        fill="#8E8E8E"
        fillOpacity="0.8"
      />
    </svg>
  );
}
